/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Fila meta mínima en paneles de filtros: hint opcional (p. ej. límite de plan) + borrar filtros.
 * Los totales y el rango van solo en CatalogPagination / pickers activos.
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { colors, typography } from '../theme/public-api';
import { OperationalFilterClearLink } from './OperationalFilterClearLink';

type Props = {
  hasActiveFilters: boolean;
  onClearFilters: () => void;
  /** Hint estático (límite de plan, etc.) — nunca totales ni estado de filtros. */
  leadingHint?: string | null;
};

export function OperationalFiltersClearRow({
  hasActiveFilters,
  onClearFilters,
  leadingHint,
}: Props) {
  if (!hasActiveFilters && !leadingHint) return null;

  return (
    <View style={styles.row}>
      {leadingHint ? (
        <Text style={styles.hint} numberOfLines={2}>
          {leadingHint}
        </Text>
      ) : (
        <View style={styles.spacer} />
      )}
      {hasActiveFilters ? <OperationalFilterClearLink onPress={onClearFilters} /> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 8,
  },
  hint: {
    ...typography.caption,
    flex: 1,
    minWidth: 0,
    color: colors.textPrimary,
    fontWeight: '800',
    fontSize: 12,
    lineHeight: 16,
  },
  spacer: {
    flex: 1,
  },
});
